import React from 'react';
import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import Modal from '../modal/modal'
import Language from '../language/language'
import { Button } from 'antd'
import { $const } from '../../helper'

import './stylesheets/message.scss'

@inject('commonStore', 'languageStore', 'authStore', 'navStore')
@withRouter
@observer
export default class Message extends React.Component {

  state = {
    showRegistrationModal: false
  }

  closeRegistationModel = () => {
    this.setState({
      showRegistrationModal: false
    })
  }

  componentDidMount () {
    this.props.authStore.getMessages('all').then(() => {
      if (this.props.authStore.messages.length > 0) {
        this.setState({
          showRegistrationModal: true
        })
      }
    })
  }

  viewTerm = (id, teamId) => {
    this.setState({
      showRegistrationModal: false
    })
    // 发送读取消息动作
    this.props.authStore.updateMessage({
      message: {
        status: 'read'
      }
    }, id).then(() => {
      this.props.history.push(`/game-apply-info/${teamId}`)
    })
  }

  formartMessage =  (messages) => {
    let message = {}
    if (messages.length > 0 ) {
      message = messages.find(item => {
       return item.message_type === $const.MESSAGE.CODE || item.message_type === $const.MESSAGE.DIVISION
      });
    }
    return message
  }

  renderRegistration = (content, lang) => {
    return (
      <div className="message-item registration-code">
        {lang === 'zh'
          ?
            [
              <p key="registration-tip-zh-1">您的战队 {content.team_name} 通过{content.event_title.zh}赛事报名，获得战队专属报名号：{content.code}</p>,
              <p key="registration-tip-zh-2">报名号为战队专属的赛事物资购买的证明之一，除本参赛队伍以外的人员需严格保密。</p>
            ]
          : 
            [ 
              <p key="registration-tip-en-1">Congratulations! Your team has qualified.</p>,
              <p key="registration-tip-en-2">Your team registration number is: {content.code}
              Please keep this information confidential.</p>,
            ]

        }
      </div>
    )
  }

  renderDivision = (content, lang) => {
    return (
      <div className="message-item division">
        {lang === 'zh'
          ?
            <p key="division-tip-zh-1">经过审核，在{content.event_title.zh}赛事中，您的战队 {content.team_name}  的最终赛区为 <span className="division">{content.zone && content.zone.zh}</span></p>
          : 
            <p key="division-tip-en-1">After review, in the {content.event_title.en}, the final division of your team {content.team_name} is  <span className="division">{content.zone && content.zone.en}</span> Division.</p>
        }
      </div>
    )
  }

  getMessageTitle = (type) => {
    if (type === $const.MESSAGE.CODE) {
      return <Language resource="REGISTRATION_CODE_GET" />
    } else if (type === $const.MESSAGE.DIVISION) {
      return <Language resource="FINAL_REGION" />
    }
    return ''
  }

  render () {
    let message = this.formartMessage(this.props.authStore.messages)
    const lang = this.props.languageStore.lang
    if (!message || !message.id || message.status === $const.MESSAGE.READ) {
      return null
    }
    let content = JSON.parse(message.content)
    return (
      <div className="messages">
        <Modal title={this.getMessageTitle(message.message_type)}  state={this.state.showRegistrationModal} close={this.closeRegistationModel}>
          {message.message_type === $const.MESSAGE.CODE  &&  this.renderRegistration(content, lang)}
          {message.message_type === $const.MESSAGE.DIVISION  &&  this.renderDivision(content, lang)}
          <div className="operate">
            <Button onClick={this.viewTerm.bind(this, message.id, content.team_id)}>
              <Language resource="VIEW" />
            </Button>
          </div>
          
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/message/message.js